export default "__VITE_PUBLIC_ASSET__8ee2f78b__"